/**
 * Mock Vesting Data for Trendphile
 * 6-month vesting visualization (mock data for testing)
 */

// Generate dates starting from a base date
const generateDate = (daysFromStart) => {
  const startDate = new Date('2025-11-27');
  startDate.setDate(startDate.getDate() + daysFromStart);
  return startDate.toISOString().split('T')[0];
};

// Mock vesting data spanning 6 months with realistic reward patterns
export const mockVestingData = [
  {
    date: '2025-11-27',
    received: 4500,
    source: 'Profile Completion',
    cumulative: 4500,
    type: 'instant',
    isTGE: true
  },
  {
    date: '2025-11-29',
    received: 500,
    source: 'Predictions',
    cumulative: 5000,
    type: 'vested'
  },
  {
    date: '2025-12-05',
    received: 100,
    source: 'Social Shares',
    cumulative: 5100,
    type: 'vested'
  },
  {
    date: '2025-12-15',
    received: 1500,
    source: 'Predictions',
    cumulative: 6600,
    type: 'vested'
  },
  {
    date: '2025-12-20',
    received: 10000,
    source: 'Referrals',
    cumulative: 16600,
    type: 'vested'
  },
  {
    date: '2025-12-28',
    received: 200,
    source: 'Social Shares',
    cumulative: 16800,
    type: 'vested'
  },
  {
    date: '2026-01-10',
    received: 500,
    source: 'Predictions',
    cumulative: 17300,
    type: 'vested'
  },
  {
    date: '2026-01-20',
    received: 100,
    source: 'Social Shares',
    cumulative: 17400,
    type: 'vested'
  },
  {
    date: '2026-02-01',
    received: 10000,
    source: 'Referrals',
    cumulative: 27400,
    type: 'vested'
  },
  {
    date: '2026-02-15',
    received: 400,
    source: 'Predictions',
    cumulative: 27800,
    type: 'vested'
  },
  {
    date: '2026-03-01',
    received: 200,
    source: 'Social Shares',
    cumulative: 28000,
    type: 'vested'
  },
  {
    date: '2026-03-15',
    received: 500,
    source: 'Predictions',
    cumulative: 28500,
    type: 'vested'
  },
  {
    date: '2026-04-01',
    received: 10000,
    source: 'Referrals',
    cumulative: 38500,
    type: 'vested'
  },
  {
    date: '2026-04-15',
    received: 300,
    source: 'Social Shares',
    cumulative: 38800,
    type: 'vested'
  },
  {
    date: '2026-05-01',
    received: 500,
    source: 'Predictions',
    cumulative: 39300,
    type: 'vested'
  },
  {
    date: '2026-05-27',
    received: 700,
    source: 'Vesting Complete',
    cumulative: 40000,
    type: 'unlock',
    isVestingEnd: true
  }
];

// Mock future projections (dashed line data)
export const mockProjections = [
  {
    date: '2026-05-27',
    projected: 40000,
    cumulative: 40000
  },
  {
    date: '2026-06-15',
    projected: 42000,
    cumulative: null
  },
  {
    date: '2026-07-01',
    projected: 44000,
    cumulative: null
  },
  {
    date: '2026-08-01',
    projected: 47000,
    cumulative: null
  }
];

// Mock TGE progress data (pre-TGE state)
export const mockTGEProgress = {
  currentUsers: 8234,
  targetUsers: 10000,
  currentPredictions: 45678,
  targetPredictions: 100000,
  usersPercentage: 82.34,
  predictionsPercentage: 45.68
};

// Mock vesting summary data
export const mockVestingSummary = {
  totalAllocated: 40000,
  unlockedClaimable: 22500,
  lockedVesting: 17500,
  breakdown: {
    profile: 4500,
    predictions: 3700,
    socialShares: 1100,
    referrals: 30000
  },
  tgeStatus: {
    isTriggered: true,
    timestamp: '2025-11-27T00:00:00Z',
    currentUsers: 10500,
    currentPredictions: 112000
  },
  vestingStatus: {
    startDate: '2025-11-27',
    endDate: '2026-05-27',
    durationDays: 182,
    elapsedDays: 45,
    remainingDays: 137,
    percentComplete: 24.7
  },
  earningsHistory: mockVestingData
};

// Pre-TGE mock data
export const mockPreTGEData = {
  totalAllocated: 5200,
  breakdown: {
    profile: 4500,
    predictions: 500,
    socialShares: 200,
    referrals: 0
  },
  tgeStatus: {
    isTriggered: false,
    currentUsers: 8234,
    currentPredictions: 45678,
    targetUsers: 10000,
    targetPredictions: 100000
  },
  estimatedUnlock: {
    instantAmount: 2600, // 50% instant at TGE
    vestedAmount: 2600   // 50% vested over 6 months
  }
};

// Post-vesting mock data
export const mockPostVestingData = {
  totalAllocated: 52000,
  totalClaimed: 52000,
  breakdown: {
    profile: 4500,
    predictions: 12500,
    socialShares: 5000,
    referrals: 30000
  },
  tgeStatus: {
    isTriggered: true,
    timestamp: '2025-11-27T00:00:00Z'
  },
  vestingStatus: {
    isComplete: true,
    completedDate: '2026-05-27',
    allRewardsInstant: true
  }
};

export default {
  mockVestingData,
  mockProjections,
  mockTGEProgress,
  mockVestingSummary,
  mockPreTGEData,
  mockPostVestingData
};

